import { Download } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import FormatDate from './formatDate';

const ExportExcel = ({ excelData, fileName }) => {
    const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    function isDateTimeStringValid(dateTimeString) {
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

        if (dateRegex.test(dateTimeString.toString().substring(0, 10))) {
            return true;
        } else {
            return false;
        }
    }

    const formatExcelData = (data) => {
        const formattedData = {};

        Object.keys(data).forEach((key) => {
            const value = data[key];

            formattedData[key.replace(/_/g, ' ')] =
                value !== null &&
                value !== undefined &&
                isDateTimeStringValid(value.toString())
                    ? FormatDate(value)
                    : value !== null &&
                      value !== undefined &&
                      !isDateTimeStringValid(value.toString())
                    ? value.toString()
                    : 'Not Yet';
        });

        return formattedData;
    };

    const exportToExcel = async () => {
        const formattedExcelData = excelData.map(formatExcelData);
        const headers =
            formattedExcelData.length > 0 ? Object.keys(formattedExcelData[0]) : [];
        const ws = XLSX.utils.json_to_sheet(formattedExcelData);
        if (headers.length > 0) {
            const colWidths = headers.map((h) => {
                const headerLen = h.length;
                const maxLen = formattedExcelData.reduce((max, row) => {
                    const v = row[h];
                    const len =
                        v !== null && v !== undefined ? v.toString().length : 0;
                    return Math.max(max, len);
                }, headerLen);
                return { wch: maxLen + 2 };
            });
            ws['!cols'] = colWidths;
        }
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
        <Tooltip title="Download Data">
            <Button
                variant="contained"
                onClick={(e) => exportToExcel(fileName)}
                color="primary"
                style={{ cursor: 'pointer', fontSize: 14 }}
                endIcon={<Download />}
            >
                Download Data
            </Button>
        </Tooltip>
    );
};

export default ExportExcel;
